<template>
  <li class="activity__detailed-card-item" v-if="activity">
    <LangRouterLink
      :to="activity.route"
      :class="['activity__detailed-card', `--hover-bg-${category.color}`]"
      :title="activity.title"
    >
      <Image v-if="activity.image" :source="activity.image" class="activity__detailed-card-image" />
      <div class="activity__detailed-card-content">
        <p :class="[color(category.color, 'darker'), 'activity__detailed-card-category']">
          {{ category.title }}
        </p>
        <h3 class="small-title">
          <span>{{ activity.title }}</span>
          <Icon id="arrow" class="activity__detailed-card-arrow" />
        </h3>
        <h4 class="activity__detailed-card-infos">{{ details(activity) }}</h4>
        <p>{{ activity.short_description }}</p>
      </div>
    </LangRouterLink>
  </li>
</template>

<script>
import { Icon, Image, LangRouterLink } from '@/components/global'
import { color, details, humanDate } from '@/helpers'
import { HasCategory } from '@/mixins'

export default {
  name: 'ActivityCard',
  mixins: [HasCategory],
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  components: { Icon, Image, LangRouterLink },
  computed: {
    category() {
      return this.getCategory(this.activity.category)
    },
  },
  methods: { color, details, humanDate },
}
</script>
